import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DocumentItem } from '../../../model/document.model';
import { Diary, Job } from '../../../model/job.model';
import { UserService } from '../../../services/user.service';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-job-tasks',
  templateUrl: './job-tasks.component.html',
  imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, MatTooltip, MatMenuItem, MatDivider]
})
export class JobTasksComponent {
  @Input() job: Job;
  @Input() noQuoteResponse: boolean;
  @Input() invoiceCreated: boolean;
  @Input() supplementQuote: boolean;
  @Input() invoicePendingReview: boolean;
  @Input() showBooking: boolean;
  @Input() displayAddInvoiceButton: boolean;
  @Input() showSelfAuthorisationCurtain: boolean;
  @Input() unSubmittedQuote: DocumentItem;
  @Input() jobStates: any;
  @Input() invoiceButtonMsg: string;
  @Input() inputFileValue: string;
  @Input() ownerName: string;
  @Input() unSubmittedDiary: Diary;
  @Output() taskButtonClicked = new EventEmitter();

  userService = inject(UserService);

  constructor() {}
}
